import { fetchAppMetrics } from '../apiRequests/api';
import {useAuth0} from "@auth0/auth0-react";
import { React, useEffect, useState } from 'react';
import Loading from './Loading';
import "../sass/components/metrics.scss"
import DatePicker from "react-datepicker";

export default function AdminMetrics(props) {
  const {getIdTokenClaims} = useAuth0();
  const [isLoading, setLoading] = useState(true)
  const [selectedStartMetricsDate, setStartMetricsDate] = useState(null);
  const [selectedEndMetricsDate, setEndMetricsDate] = useState(null);
  const [appMetrics, setAppMetrics] = useState({});

  async function handleMetricsDateChange() {
    let startDate = selectedStartMetricsDate;
    if (selectedStartMetricsDate === null) {
      startDate = new Date();
      startDate.setDate(1);
      startDate.setHours(0, 0, 0, 0);
      setStartMetricsDate(startDate);
    }
    let endDate = selectedEndMetricsDate;
    if (selectedEndMetricsDate === null) {
      endDate = new Date();
      endDate.setHours(23, 59, 59, 0);
      setEndMetricsDate(endDate);
    }

    const token = await getIdTokenClaims();
    fetchAppMetrics({
      startDate: startDate.getTime(),
      endDate: endDate.getTime(),
    }, token.__raw).then((metricsData) => {
      setAppMetrics(metricsData);
      setLoading(false);
    });
  }

  useEffect(() => {
    handleMetricsDateChange();
  }, [appMetrics])
  return (
    <div>
      {isLoading ?
        <Loading isLoading={true}/>
        :
          <div className="metrics-container">
            <h2 className='page-title v2'>Trade App Metrics</h2>
            <div className="metrics-dates">
              <div className="metrics-date">
                From:
                <DatePicker selected={selectedStartMetricsDate} onChange={(date) => {
                  setLoading(true);
                  date.setHours(0, 0, 0, 0);
                  setStartMetricsDate(date);
                  handleMetricsDateChange();
                }} dateFormat={'d/M/yyyy'}/>
              </div>
              <div className="metrics-date">
                To:
                <DatePicker selected={selectedEndMetricsDate} onChange={(date) => {
                  setLoading(true);
                  date.setHours(23, 59, 59, 0);
                  setEndMetricsDate(date);
                  handleMetricsDateChange();
                }} dateFormat={'d/M/yyyy'}/>
              </div>
            </div>
            <div className="metrics-items">
              <div className="metrics-item">
                <div className="metric-title">AVG Order total</div>
                <div className="metric-value">{appMetrics['order_total_avg']}</div>
              </div>
              <div className="metrics-item">
                <div className="metric-title">Orders number</div>
                <div className="metric-value">{appMetrics['order_count']}</div>
              </div>
              <div className="metrics-item">
                <div className="metric-title">Unique logged in users</div>
                <div className="metric-value">{appMetrics['user_count']}</div>
              </div>
            </div>
          </div>
      }
    </div>
  );
}